import getRandomInt from '../functions/getRandomInt';
//import getRandomIntArray from '../functions/getRandomIntArray';
import uqnJoin from '../functions/uqnJoin';
export default function random(type, sign) {
    if (typeof type === "undefined" || type == 0) {
        type = getRandomInt(1, 6);
    }
    if (type < 3) { // real coefficients, cubic
        const x = getRandomInt(0, 9);
        const y = getRandomInt(1, 9);
        const r = getRandomInt(1, 9);
        if (typeof sign === "undefined") {
            sign = getRandomInt(0, 7);
        }
        return uqnJoin([type, x, y, r, sign]);
    }
    else if (type < 7) { // real coefficients, quartic. complex coefficients, quadratic
        const x1 = getRandomInt(0, 9);
        const y1 = getRandomInt(1, 9);
        const y2 = getRandomInt(1, 9);
        let x2, sign;
        if (type == 3 || type == 5 || type == 6) { // 4 complex roots or two complex roots
            x2 = getRandomInt(0, 9);
            if (type == 3) {
                sign = getRandomInt(0, 3);
            }
            else {
                sign = getRandomInt(0, 9);
            }
        }
        else { // type == 4: 2 complex, 2 real
            x2 = getRandomInt(1, 9);
            sign = getRandomInt(0, 7);
        }
        return uqnJoin([type, x1, y1, x2, y2, sign]);
    }
}
